/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityIncognitoSpyIcon16Solid = forwardRef('SecurityIncognitoSpyIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "m3.305 3.13-.988 4.125H.877a.875.875 0 1 0 0 1.75H15.12a.875.875 0 0 0 0-1.75h-1.437l-.988-4.125a2.05 2.05 0 0 0-3.123-1.234l-1.269.838a.55.55 0 0 1-.606 0l-1.269-.838A2.05 2.05 0 0 0 3.305 3.13Z" }),
        React.createElement("path", { d: "M9.25 10H13a1 1 0 0 1 1 1v1a2.75 2.75 0 1 1-5.5 0v-.5h-1v.5A2.75 2.75 0 1 1 2 12v-1a1 1 0 0 1 1-1h6.25Z" })));
});
